module.exports = __webpack_public_path__ + "img/pleasure-icon-3.1c97e4d4.svg";